import { render, staticRenderFns } from "./AddImagemProductComponent.vue?vue&type=template&id=5358e693&scoped=true"
import script from "./AddImagemProductComponent.vue?vue&type=script&lang=js"
export * from "./AddImagemProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358e693",
  null
  
)

export default component.exports